"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FeaturesContentSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _featuresContentItem = _interopRequireDefault(require("../../../page-body/other/features-content-item"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _countdownClock = _interopRequireDefault(require("@site/pattern-library-core/countdown-clock"));
/* eslint-disable no-nested-ternary */
const SectionWrapper = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "SectionWrapper",
  class: "pl-s1ha3ipr",
  vars: {
    "s1ha3ipr-0": [({
      backgroundColor
    }) => backgroundColor ? backgroundColor : _intents.default.ux.box.backgroundColor],
    "s1ha3ipr-1": [({
      verticalMargin
    }) => (0, _patternLibraryUtils.getVerticalSpace)(verticalMargin, true)],
    "s1ha3ipr-4": [({
      verticalMargin
    }) => (0, _patternLibraryUtils.getVerticalSpace)(verticalMargin)]
  }
});

/**
 * FeaturesContentSection component.
 * @module FeaturesContentSection
 *
 * @param {Object} props React props
 * @param {string} props._name The tracking name for the component
 * @param {string} props.eyebrow Eyebrow text
 * @param {string} props.heading Heading text
 * @param {string} props.description Description text
 * @param {array} props.items Array of child Features Content Items
 * @param {string} props.featureImagePlacement Feature image placement start order
 * @param {object} props.invert Item background color
 * @param {object} props.backgroundColor Item background color
 * @param {string} props.verticalMargin vertical outer spacing
 * @param {String} props.partial Theme partial
 * @returns {React.ReactElement} FeaturesContentSection component
 * @public
 */

function FeaturesContentSection({
  _name,
  items,
  featureImagePlacement = 'start-left',
  invert = false,
  backgroundColor,
  verticalMargin = 'none',
  padding,
  partial,
  countdownClock,
  ...headlineProps
}) {
  const {
    eyebrow,
    heading,
    headlineTag
  } = headlineProps;
  const countdownClockElement = countdownClock && (/*#__PURE__*/_react.default.isValidElement(countdownClock) ? countdownClock : /*#__PURE__*/_react.default.createElement(_countdownClock.default, countdownClock));
  return /*#__PURE__*/_react.default.createElement(SectionWrapper, {
    _name: _name,
    dataCy: "features-content-section",
    partial: partial || (invert ? 'dark1' : ''),
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
    verticalMargin: verticalMargin,
    className: "legacy-container",
    padding: padding
  }, (eyebrow || heading) && /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({}, headlineProps, {
    headlineTag: headlineTag || (eyebrow ? 'h3' : 'h2')
  })), countdownClockElement, items?.map((item, i) => {
    if (featureImagePlacement === 'off') {
      return /*#__PURE__*/_react.default.createElement(_featuresContentItem.default, (0, _extends2.default)({
        key: i
      }, item, {
        parentSectionPadding: padding
      }));
    }
    return i % 2 === 0 && featureImagePlacement === 'start-left' || i % 2 !== 0 && featureImagePlacement === 'start-right' ? /*#__PURE__*/_react.default.createElement(_featuresContentItem.default, (0, _extends2.default)({
      key: i
    }, item, {
      parentSectionPadding: padding,
      layout: "split-reverse"
    })) : /*#__PURE__*/_react.default.createElement(_featuresContentItem.default, (0, _extends2.default)({
      key: i
    }, item, {
      parentSectionPadding: padding,
      layout: "split"
    }));
  }));
}
FeaturesContentSection.propTypes = {
  _name: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_featuresContentItem.default.propTypes)),
  featureImagePlacement: _propTypes.default.oneOf(['start-left', 'start-right', 'off']),
  invert: _propTypes.default.bool,
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string,
    contrastRgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  padding: _propTypes.default.oneOf(['none', 'small', 'medium', 'large']),
  partial: _propTypes.default.string,
  countdownClock: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]),
  ..._index.default.propTypes
};